import {useFormContext} from "react-hook-form";
import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form.tsx";
import {Input} from "@/components/ui/input.tsx";
import FormHeader from "@/components/booking/FormHeader.tsx";
import {z} from "zod";
import {BookingFormSchema} from "@/components/booking/form/BookingFormSchema.ts";

export function CommunityForm() {
    const {control} = useFormContext<z.infer<typeof BookingFormSchema>>();

    return (
        <div className={"os-app-row os-grid os-grid-cols-1 md:os-grid-cols-2 os-gap-4"}>
            <FormHeader>
                Department Contact Information
            </FormHeader>
            <FormField
                control={control}
                name="commDepartment"
                render={({field}) => (
                    <FormItem className={"md:os-col-span-2"}>
                        <FormLabel>Name of Department</FormLabel>
                        <FormControl>
                            <Input required={true} placeholder={"Name of Department"} {...field} />
                        </FormControl>
                        <FormMessage/>
                    </FormItem>
                )}
            />
            <FormField
                control={control}
                name="commCaseName"
                render={({field}) => (
                    <FormItem>
                        <FormLabel>Case Manager Name</FormLabel>
                        <FormControl>
                            <Input required={true} placeholder={"Case Manager Name"} {...field} />
                        </FormControl>
                        <FormMessage/>
                    </FormItem>
                )}
            />
            <FormField
                control={control}
                name="commCaseEmail"
                render={({field}) => (
                    <FormItem>
                        <FormLabel>Case Manager Email</FormLabel>
                        <FormControl>
                            <Input type={"email"} required={true} placeholder={"Case Manager Email"} {...field} />
                        </FormControl>
                        <FormMessage/>
                    </FormItem>
                )}
            />
            <FormField
                control={control}
                name="commCasePhone"
                render={({field}) => (
                    <FormItem>
                        <FormLabel>Case Manager Phone</FormLabel>
                        <FormControl>
                            <Input type={"tel"} required={true} placeholder={"Case Manager Phone"} {...field} />
                        </FormControl>
                    </FormItem>
                )}
            />
            <div></div>
            <FormField
                control={control}
                name="commInvoiceEmail"
                render={({field}) => (
                    <FormItem>
                        <FormLabel>Department Invoice Email</FormLabel>
                        <FormControl>
                            <Input type={"email"} required={true} placeholder={"Department Invoice Email"} {...field} />
                        </FormControl>
                        <FormMessage/>
                    </FormItem>
                )}
            />
            <FormField
                control={control}
                name="commPurchaseOrder"
                render={({field}) => (
                    <FormItem>
                        <FormLabel>Department Purchase Order Number</FormLabel>
                        <FormControl>
                            <Input placeholder={"Department Purchase Order Number"} {...field} />
                        </FormControl>
                        <FormMessage/>
                    </FormItem>
                )}
            />
        </div>
    )
}